import React from "react";
import { Col } from "@components/ui";
import { FlexContainer } from "@components/ui/flex_container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import Image from "next/image";

export default function VideoPreview({ company, previewImage, title, onClick, alt }) {
    return (
        <Col className="video-preview">
            <FlexContainer
                column
                justifyContent="center"
                className="text-center video-preview-container"
                onClick={() => {
                    onClick?.();
                }}
            >
                <Image
                    priority
                    alt={alt}
                    layout="fill"
                    className="video-preview-image"
                    src={previewImage}
                />

                <FontAwesomeIcon className="video-play-icon" icon={faPlay} size="3x" />
            </FlexContainer>
            <FlexContainer className="video-info-container">
                {company?.logo && (
                    <picture>
                        <img className="company-logo" src={company?.logo} />
                    </picture>
                )}
                <div>
                    <h3>{title}</h3>
                    <h4>{company?.name}</h4>
                </div>
            </FlexContainer>
        </Col>
    );
}
